module.exports = __webpack_public_path__ + "static/media/38-iveco-mercedes.45ee1775.jpg";